var React = require('react');

function Video (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.8571 2.71429L13.8571 7L19.8571 11.2857V2.71429Z","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.1429 1H2.71429C1.76751 1 1 1.76751 1 2.71429V11.2857C1 12.2325 1.76751 13 2.71429 13H12.1429C13.0896 13 13.8571 12.2325 13.8571 11.2857V2.71429C13.8571 1.76751 13.0896 1 12.1429 1Z","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Video.defaultProps = {"preserveAspectRatio":"xMinYMin meet","viewBox":"0 0 21 14","fill":"none"};

module.exports = Video;

Video.default = Video;
